import React from "react";
import { useTemplateStore } from "@/zustand/templateStore.js";
import { RegionDropdown } from "react-country-region-selector";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const RegionField = ({ label, error, country, handleChange, name, value }) => {
  const stateLabel = window?.post_template.checkout_v6_form?.checkout_v6_formLabels?.tr_checkout_v6_form_stateLabel;
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <div className={s.inputContainer}>
      <div
        className={cn(
          s.input,
          s.input__text,
          error && s.input__error,
          isEnhancedContrast && s.enhancedContrast,
          isEnhancedContrast && error && s.enhancedContrast__error
        )}
      >
        {label && (
          <span
            className={cn(s.styledLabel, s.styledLabel__active, isEnhancedContrast && s.styledLabel__enhancedContrast)}
          >
            {label}
          </span>
        )}
        <div className={s.input__customSelect}>
          <RegionDropdown
            id="region"
            country={country?.toUpperCase()}
            countryValueType={"short"}
            valueType={"short"}
            value={value}
            defaultOptionLabel={stateLabel}
            autoComplete="address-level1"
            classes={cn(s.input__select, s.overflowedSelect, isEnhancedContrast && s.enhancedContrast)}
            name={name}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </div>
      </div>
      {error && (
        <div className={s.formError} style={{ marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RegionField;
